export default "/magic-eth.7624c77dcbcc9f2067ea7a519bb92146.svg";